export default __webpack_public_path__ + "static/5-f1517410e3ece0967e88c0ea789e7d42.png";